export const categories = [
  { id: 'all', name: '全部', slug: 'all' },
  { id: 'romance', name: '恋爱', slug: 'romance' },
  { id: 'fantasy', name: '奇幻', slug: 'fantasy' },
  { id: 'action', name: '热血', slug: 'action' },
  { id: 'drama', name: '都市', slug: 'drama' },
  { id: 'thriller', name: '悬疑', slug: 'thriller' },
  { id: 'comedy', name: '搞笑', slug: 'comedy' },
  { id: 'horror', name: '惊悚', slug: 'horror' },
  { id: 'slice-of-life', name: '日常', slug: 'slice-of-life' },
];

export const mangaList = [
  {
    id: 1,
    title: '恶女的定义',
    author: '金智慧',
    category: 'romance',
    rating: 4.8,
    views: 1280000,
    chapters: 86,
    status: '连载中',
    cover: 'https://readdy.ai/api/search-image?query=A%20beautiful%20Korean%20manhwa%20style%20illustration%20of%20an%20elegant%20female%20character%20with%20long%20dark%20hair%20wearing%20a%20sophisticated%20dress%2C%20soft%20warm%20lighting%2C%20romantic%20atmosphere%2C%20webtoon%20cover%20art%20style%2C%20clean%20minimal%20background%20with%20subtle%20floral%20elements&width=400&height=560&seq=manga-cover-01&orientation=portrait',
    description: '重生成为帝国最臭名昭著的恶女，她决定改变自己的命运。然而，当她开始展现善良的一面时，周围人的反应却出乎意料。一场关于救赎与爱情的华丽逆转剧就此展开。',
    tags: ['重生', '宫廷', '逆袭', '虐恋'],
  },
  {
    id: 2,
    title: '剑与魔法之诗',
    author: '朴志勋',
    category: 'fantasy',
    rating: 4.9,
    views: 2150000,
    chapters: 124,
    status: '连载中',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20fantasy%20illustration%20of%20a%20male%20warrior%20with%20silver%20armor%20holding%20a%20glowing%20sword%2C%20magical%20energy%20surrounding%20him%2C%20epic%20adventure%20cover%20art%2C%20dramatic%20lighting%2C%20webtoon%20style%2C%20clean%20minimal%20background&width=400&height=560&seq=manga-cover-02&orientation=portrait',
    description: '在一个魔法与剑术并存的世界里，少年艾伦意外觉醒了传说中的双系魔法。为了寻找失踪的师父，他踏上了充满危险与奇迹的旅程。',
    tags: ['魔法', '冒险', '成长', '战斗'],
  },
  {
    id: 3,
    title: '暗夜追踪者',
    author: '李东旭',
    category: 'action',
    rating: 4.7,
    views: 980000,
    chapters: 62,
    status: '连载中',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20action%20illustration%20of%20a%20mysterious%20male%20character%20in%20a%20dark%20trench%20coat%20standing%20in%20a%20rainy%20alley%20at%20night%2C%20noir%20atmosphere%2C%20dramatic%20shadows%2C%20webtoon%20cover%20art%20style%2C%20clean%20composition&width=400&height=560&seq=manga-cover-03&orientation=portrait',
    description: '白天是普通上班族，夜晚化身城市暗影中的追踪者。拥有特殊能力的金俊浩，在追查一起连环失踪案时，逐渐揭开了一个隐藏在都市之下的巨大阴谋。',
    tags: ['都市', '超能力', '悬疑', '战斗'],
  },
  {
    id: 4,
    title: '社长请多指教',
    author: '崔秀英',
    category: 'romance',
    rating: 4.6,
    views: 1560000,
    chapters: 95,
    status: '连载中',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20romance%20manhwa%20illustration%20of%20a%20handsome%20male%20CEO%20in%20a%20suit%20and%20a%20cheerful%20female%20office%20worker%2C%20office%20romance%20setting%2C%20warm%20pastel%20colors%2C%20webtoon%20cover%20art%20style%2C%20clean%20minimal%20background&width=400&height=560&seq=manga-cover-04&orientation=portrait',
    description: '刚毕业的职场菜鸟林小美，阴差阳错成为了冷面社长的私人秘书。原本以为是一份普通工作，没想到却是一场心跳加速的办公室恋爱。',
    tags: ['职场', '恋爱', '甜宠', '喜剧'],
  },
  {
    id: 5,
    title: '末日生存法则',
    author: '郑宇成',
    category: 'thriller',
    rating: 4.8,
    views: 1890000,
    chapters: 108,
    status: '连载中',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20thriller%20illustration%20of%20a%20group%20of%20survivors%20in%20a%20post-apocalyptic%20city%20with%20ruined%20buildings%2C%20tense%20atmosphere%2C%20dramatic%20lighting%2C%20webtoon%20cover%20art%20style%2C%20clean%20composition&width=400&height=560&seq=manga-cover-05&orientation=portrait',
    description: '未知病毒爆发后的世界，文明崩塌，秩序瓦解。一群幸存者在这个残酷的新世界中挣扎求生，而人性的善恶在末日面前被无限放大。',
    tags: ['末日', '生存', '人性', '惊悚'],
  },
  {
    id: 6,
    title: '女神降临',
    author: '韩智恩',
    category: 'drama',
    rating: 4.5,
    views: 2340000,
    chapters: 142,
    status: '已完结',
    cover: 'https://readdy.ai/api/search-image?query=A%20beautiful%20Korean%20manhwa%20illustration%20of%20a%20stunning%20female%20character%20transforming%20from%20plain%20to%20gorgeous%20with%20makeup%2C%20glamorous%20makeover%20theme%2C%20warm%20soft%20lighting%2C%20webtoon%20cover%20art%20style%2C%20clean%20minimal%20background&width=400&height=560&seq=manga-cover-06&orientation=portrait',
    description: '因为外貌而饱受欺凌的女孩，通过化妆技巧实现了惊人的蜕变。在新的学校里，她以完美的形象成为了众人眼中的"女神"，但美丽的背后隐藏着不为人知的秘密。',
    tags: ['校园', '美容', '成长', '恋爱'],
  },
  {
    id: 7,
    title: '搞笑一家人',
    author: '姜虎东',
    category: 'comedy',
    rating: 4.4,
    views: 890000,
    chapters: 76,
    status: '连载中',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20comedy%20manhwa%20illustration%20of%20a%20funny%20family%20with%20exaggerated%20expressions%2C%20colorful%20and%20playful%20art%20style%2C%20warm%20family%20scene%2C%20webtoon%20cover%20art%20style%2C%20clean%20minimal%20background&width=400&height=560&seq=manga-cover-07&orientation=portrait',
    description: '一个平凡却又充满笑料的四口之家，每天都在上演令人捧腹的日常闹剧。爸爸的冷笑话、妈妈的碎碎念、兄妹的斗嘴，构成了这部温馨又搞笑的家庭喜剧。',
    tags: ['家庭', '搞笑', '日常', '温馨'],
  },
  {
    id: 8,
    title: '午夜图书馆',
    author: '尹书妍',
    category: 'horror',
    rating: 4.6,
    views: 720000,
    chapters: 54,
    status: '连载中',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20horror%20manhwa%20illustration%20of%20a%20mysterious%20old%20library%20at%20midnight%20with%20a%20female%20character%20holding%20a%20candle%2C%20eerie%20atmosphere%2C%20dark%20moody%20lighting%2C%20webtoon%20cover%20art%20style%2C%20clean%20composition&width=400&height=560&seq=manga-cover-08&orientation=portrait',
    description: '深夜的图书馆里，隐藏着一本不能翻开的禁书。大学生韩素希无意中打开了它，从此被卷入了一系列离奇恐怖的超自然事件中。',
    tags: ['恐怖', '超自然', '校园', '解谜'],
  },
  {
    id: 9,
    title: '猫咪咖啡厅',
    author: '张美英',
    category: 'slice-of-life',
    rating: 4.3,
    views: 650000,
    chapters: 48,
    status: '连载中',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20slice-of-life%20manhwa%20illustration%20of%20a%20cozy%20cat%20cafe%20with%20cute%20cats%20and%20a%20gentle%20female%20owner%2C%20warm%20pastel%20colors%2C%20relaxing%20atmosphere%2C%20webtoon%20cover%20art%20style%2C%20clean%20minimal%20background&width=400&height=560&seq=manga-cover-09&orientation=portrait',
    description: '辞去高压工作的李允儿，在首尔的小巷里开了一家猫咪咖啡厅。在这里，她遇见了形形色色的顾客和他们的故事，也找到了属于自己的幸福。',
    tags: ['治愈', '猫咪', '日常', '温暖'],
  },
  {
    id: 10,
    title: '帝国之剑',
    author: '金泰亨',
    category: 'fantasy',
    rating: 4.9,
    views: 3100000,
    chapters: 168,
    status: '连载中',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20fantasy%20manhwa%20epic%20illustration%20of%20a%20young%20king%20on%20a%20throne%20with%20a%20legendary%20sword%2C%20imperial%20palace%20background%2C%20grand%20scale%2C%20dramatic%20light%2C%20webtoon%20cover%20art%20style%2C%20clean%20composition&width=400&height=560&seq=manga-cover-10&orientation=portrait',
    description: '帝国最年轻的皇帝，手握传说中的圣剑，肩负着守护整个大陆的使命。面对外敌入侵和内廷阴谋，他必须在权力与正义之间做出抉择。',
    tags: ['帝国', '战争', '权谋', '史诗'],
  },
  {
    id: 11,
    title: '恋与制作人',
    author: '宋慧乔',
    category: 'romance',
    rating: 4.7,
    views: 1780000,
    chapters: 112,
    status: '连载中',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20romance%20manhwa%20illustration%20of%20a%20female%20game%20producer%20surrounded%20by%20four%20handsome%20male%20characters%20with%20different%20styles%2C%20romantic%20comedy%20vibe%2C%20webtoon%20cover%20art%20style%2C%20clean%20minimal%20background&width=400&height=560&seq=manga-cover-11&orientation=portrait',
    description: '身为游戏公司制作人的女主角，在开发恋爱模拟游戏的过程中，意外发现自己周围的四个完美男人似乎都与游戏中的角色有着神秘的联系。',
    tags: ['恋爱', '游戏', '多男主', '甜宠'],
  },
  {
    id: 12,
    title: '热血格斗部',
    author: '权志龙',
    category: 'action',
    rating: 4.5,
    views: 1120000,
    chapters: 90,
    status: '已完结',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20action%20manhwa%20illustration%20of%20a%20young%20martial%20artist%20in%20a%20fighting%20stance%2C%20dynamic%20action%20pose%2C%20intense%20expression%2C%20martial%20arts%20theme%2C%20webtoon%20cover%20art%20style%2C%20clean%20minimal%20background&width=400&height=560&seq=manga-cover-12&orientation=portrait',
    description: '转学到新学校的格斗天才，加入了濒临解散的格斗部。他带领着一群性格各异的队友，一路过关斩将，向着全国大赛的冠军发起冲击。',
    tags: ['格斗', '校园', '热血', '友情'],
  },
];